module.exports = __webpack_public_path__ + "img/agenda_lede_image.bba06a0b.png";